import { useCauseParam } from 'core/Hooks';
import { useNavigate } from 'react-router-dom';
import { SimpleDonationPage as SimpleDonations } from 'store';

export default function SimpleDonationPage() {
  const navigate = useNavigate();
  const { data: paramCause } = useCauseParam();

  return (
    <SimpleDonations causeId={paramCause?.uuid} onLastStepComplete={() => navigate('/offers')} />
  );
}
